import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Text, Pane } from "evergreen-ui";
import { APP_URL } from "../config";

function ReportRequest() {
  useEffect(() => {
    window.open(`${APP_URL}/reports/requests`, "_blank");
  }, []);

  return (
    <Pane
      height={240}
      alignItems="center"
      justifyContent="center"
      display="flex"
    >
      <Text color="muted">
        {`This report is being upgraded. Find the old report here: `}
        <Link to={`${APP_URL}/reports/requests`}>
          {`${APP_URL}/reports/requests`}
        </Link>
      </Text>
    </Pane>
  );
}

export default ReportRequest;
